export const ItemType = {
  Download: "download",
  Content: "content",
};

export const ContentItemType = {
  Lesson: "lesson",
  ScrollLesson: "lesson_slide_scroll",
};
